import React, { Fragment } from "react";
import { useEffectOnce } from "../hooks/useeffectonce";
import { useDispatch, useSelector } from "react-redux";
import { clearGenericError } from "../redux/slices/genericerrorpageslice";
import { Navigate } from "react-router-dom";
import { ROUTING_PATHS } from "../settings";

export const GenericErrorPage = props => {
    const dispatch = useDispatch();
    const genericError = useSelector(state => state.genericErrorPage);
    
    useEffectOnce(() =>{
        return () => {
            dispatch(clearGenericError());
        }
    }, []);

   if (!genericError)
        return <Navigate to={ROUTING_PATHS.home} replace={true} />

   return (
        <Fragment>
            <div className="genericerror-page" >
                <h1>
                    {genericError.title}
                </h1>
                <h3 style={{marginTop: 24}}>
                    {genericError.body}
                </h3>
            </div>
            <style>
                {
                    `
                        .genericerror-page
                        {
                            height: 100%;
                            position: relative;
                            background-color: transparent;
                        }
                    `
                }
            </style>
        </Fragment>
   );
};

//export const GenericErrorPage = {Component: GenericError};
